import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { Notification } from "@tql/ui-components-react/kendo/notification";
import { alertCircle, flag_01 } from "@tql/ui-components-react/untitled/icons";

import type { ShipmentExceptionType } from "../../constants/exception-labels.ts";
import { SHIPMENT_EXCEPTION_LABELS } from "../../constants/exception-labels.ts";

export const Exception = ({
	exceptionCount = 0,
	type = "immediateActionExceptions",
	message,
	onClick,
}: {
	exceptionCount?: number;
	type?: ShipmentExceptionType;
	message?: string;
	onClick?: () => void;
}) => {
	const handleKeyDown = (e: React.KeyboardEvent) => {
		if (onClick && (e.key === "Enter" || e.key === " ")) {
			e.preventDefault();
			onClick();
		}
	};

	if (exceptionCount === 0) {
		return null;
	}

	return (
		<div
			onClick={onClick}
			onKeyDown={handleKeyDown}
			role={onClick ? "button" : undefined}
			style={{ cursor: onClick ? "pointer" : "default" }}
			tabIndex={onClick ? 0 : -1}
		>
			<Notification
				type={{
					style: type === "immediateActionExceptions" ? "error" : "info",
					icon: false,
				}}
			>
				<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
					<SvgIcon
						icon={type === "immediateActionExceptions" ? flag_01 : alertCircle}
						size={"medium"}
					/>
					<span>
						{exceptionCount} {message ?? SHIPMENT_EXCEPTION_LABELS[type].banner}
					</span>
				</div>
			</Notification>
		</div>
	);
};
